module.exports = __webpack_public_path__ + "img/express_empty.343bbbf9.png";